import { handleActions } from "redux-actions";
import { UTILITIES } from "constants/action-types";
import { initialBaseState, initialFetchState, updateActions, IFetchStoreState } from "./base-reducers";
import { IUser } from "containers/management/management-types";
import { combineReducers } from "redux";
import { AccountType } from "types/user";

export interface IAssortmentSuperusersState {
    superusers: IFetchStoreState<IUser[]>;
    suggestions: IFetchStoreState<IUser[]>;
}

export const assortmentSuperusers = combineReducers<IAssortmentSuperusersState>({
    superusers: handleActions<IFetchStoreState<IUser[]>>(
        {
            [UTILITIES.ASSORTMENT_SUPERUSERS.SUPERUSERS.FETCH.START]: (state) => ({
                ...state,
                isFetching: true,
                error: null,
            }),
            [UTILITIES.ASSORTMENT_SUPERUSERS.SUPERUSERS.FETCH.SUCCESS]: (state, action) => {
                const { data } = action;
                const superusers = data.filter((user: IUser) => user.account_type === AccountType.NUORDER);

                return {
                    ...state,
                    payload: superusers ?? [],
                    isFetching: false,
                    error: null,
                };
            },
            [UTILITIES.ASSORTMENT_SUPERUSERS.SUPERUSERS.FETCH.ERROR]: (state, action) => ({
                ...state,
                isFetching: false,
                error: action.error,
            }),
            ...updateActions(UTILITIES.ASSORTMENT_SUPERUSERS.SUPERUSERS),
        } as any,
        initialBaseState
    ),
    suggestions: handleActions<IFetchStoreState<IUser[]>>(
        {
            [UTILITIES.ASSORTMENT_SUPERUSERS.SUGGESTIONS.FETCH.SUCCESS]: (state, action) => ({
                ...state,
                payload: action.payload.data,
            }),
        } as any,
        initialFetchState
    ),
});
